import { customAlphabet, nanoid } from 'nanoid/non-secure'

export const numbers = '0123456789'
export const lowercase = 'abcdefghijklmnopqrstuvwxyz'
export const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
export const alphanumeric = numbers + lowercase + uppercase
export const hexadecimalLowercase = numbers + 'abcdef'
export const hexadecimalUppercase = numbers + 'ABCDEF'
export const nolookalikes = '346789ABCDEFGHJKLMNPQRTUVWXYabcdefghijkmnpqrtwxyz'
export const nolookalikesSafe = '6789BCDFGHJKLMNPQRTWbcdfghjkmnpqrtwz'

const charsets = {
  numbers,
  lowercase,
  uppercase,
  hexadecimalLowercase,
  hexadecimalUppercase,
  nolookalikes,
  nolookalikesSafe
}

export function generateId(charsetName: keyof typeof charsets, length: number) {
  return customAlphabet(charsets[charsetName])(length)
}

generateId.channelId = () => generateId('lowercase', 8)
generateId.accessToken = () => generateId('hexadecimalLowercase', 40)

generateId.dialogId = () => nanoid(9)
generateId.stepId = () => nanoid(9)
generateId.commentId = () => nanoid(9)
generateId.intentHeadlineId = () => nanoid(9)
